import { connect } from 'react-redux';

import { carrierDataSelectors } from 'wanderu-ducks-carriers';
import { liveCheckTripAction } from 'wanderu-ducks-live-check';
import { tripSelectors } from 'wanderu-ducks-trips';

import WaypointComponent from '../components/Itinerary/Waypoint/Waypoint';

function mapStateToProps(state, ownProps) {
    const {
        carrierId,
        operatorName,
        seats,
        tripId,
        wheelchairs,
    } = ownProps;

    const { pricing } = tripSelectors.selectTripPrices(state, tripId, seats, wheelchairs) || [];
    const { selectedFare } = tripSelectors.selectTripData(state, tripId) || {};

    const lcParams = {
        seats,
        selectedFare,
        tripId,
        wheelchairs,
    };

    let displayName = operatorName;
    if (carrierId) {
        const carrier = carrierDataSelectors.selectCarrierData(state, carrierId);
        displayName = carrier?.name;
    }

    return {
        displayName,
        liveChecksInProgress: liveCheckTripAction.selectWorking(state, lcParams),
        price: pricing[0],
    };
}

export {
    mapStateToProps,
};

export default connect(mapStateToProps)(WaypointComponent);
